import PreventMultipleSubmit from "./PreventMultipleSubmit";
new PreventMultipleSubmit();